import Request from "../../services/Request";
import ResponseChecker from "../../services/ResponseChecker";
import NotiMessage from "../../services/NotiMessage";

const notiMessage = new NotiMessage("success");

const errorMessage = new NotiMessage("error");

// URL //
const eachUrl = "member/getEach?";
const allUrl = "member/get?";
const storeUrl = "member/store";
const updateUrl = "member/update?";
const deleteUrl = "member/delete?";

const state = {
  members: [],
  member: {},
};
const getters = {};
const mutations = {
  SETS(state, payload) {
    state.members = payload.data.data;
  },
  SET(state, payload) {
    state.member = payload.data.data;
  },
  ADD(state, payload) {
    state.members.push(payload.data.data);
  },
  REMOVE(state, payload) {
    const members = state.members.filter((item) => item.id != payload.id);
    state.members = [...members];
  },
};

const actions = {
  async get({ commit }) {
    const response = await Request.get_data(allUrl);
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess()) commit("SETS", response);
  },
  async getEach({ commit }, id) {
    const response = await Request.get_data(eachUrl, {
      column: "id",
      value: id,
    });
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess()) commit("SET", response);
  },
  async create({ commit }, payload) {
    const response = await Request.post_data(storeUrl, payload);
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess()) {
      commit("ADD", response);
      notiMessage.displayNotiMsg("Saved Success");
      return true;
    }
    errorMessage.displayNotiMsg(response.data.message);
    return false;
  },
  async update(context, payload) {
    const response = await Request.post_data(updateUrl, payload);
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess()) {
      notiMessage.displayNotiMsg("Updated Success");
      return true;
    }
    return false;
  },
  async delete({ commit }, payload) {
    const response = await Request.post_data(deleteUrl, payload);
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess()) {
      commit("REMOVE", payload);
      notiMessage.displayNotiMsg("Deleted Success");
      return true;
    }
    return false;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
